<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" class="pt-0">
        <v-row>
          <v-col cols="3" md="2" align-self="end">
            <v-btn @click="create">
              <v-icon>add</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3" md="3" align-self="end">
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Suche"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>

      </v-col>

      <v-col cols="12" md="12">

        <v-data-table
        :headers="headers"
        :items="deviceList"
        :search="search"
        fixed-header
        :height="tableHeight"
        >

          <template v-slot:item.comment="{ item }">
            <span v-html="item.comment"></span>
          </template>
          <template v-slot:item.created="{ item }">
            {{formatDateTime(item.created)}}
          </template>
          <template v-slot:item.edited="{ item }">
            {{formatDateTime(item.edited)}}
          </template>

          <template v-slot:item.name="{ item }">
            <span class="handpointer" @click="editItem(item)">{{item.name}}</span>
          </template>
          <template v-slot:item.action="{ item }">
            {{actionNames[item.action]}}
          </template>
          <template v-slot:item.actionBtns="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
              edit
            </v-icon>
            <v-icon
            small
            @click="deleteItem(item)"
            >
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DialogCreateComment ref="dlgCreateComment" @createItem="doCreateItem"></DialogCreateComment>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import DialogCreateComment from "@/components/dialogs/DialogCreateComment";
import DialogDeleteItem from "@/components/dialogs/DialogDeleteItem";
import moment from "moment";

export default {
  name: 'TableComments',
  props: {
    companyId: String,
    deviceId: String
  },
  components: {DialogCreateComment,DialogDeleteItem},
  data () {
    return {

      currentDevice: null,
      search: null,
      tableHeight: 100,

      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Subject', value: 'subject'},
        {text: 'Text', value: 'body'},
        {text: 'Erstellt', value: 'created', width: 160},
        {text: 'Verändert', value: 'edited', width: 160},
        {text: 'Aktion', value: 'actionBtns'}
      ],
      actionNames: {
        'manual': 'Default',
        'phone': 'Telefonat',
        'mail': 'E-mail',
        'contact': 'Kontakt',
      },
      deviceList: []
    }
  },

  methods: {

    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    doCreateItem: function (item) {
      if (this.companyId) {
        item.guidCompany = this.companyId
      }
      if (this.deviceId) {
        item.guidDevice = this.deviceId
      }
      Vue.prototype.$api.createComment(item, this.reload)
    },
    create: function () {
      const cmp = this
      const newMail = {
        name: 'Neues Template',
        userGuid: Vue.prototype.$api.getCredentials().data.guidParent,
        language: 'de'
      }
      Vue.prototype.$api.createMail(newMail, function(item) {
        cmp.$router.push('/admin/mails/' + item.guid)
      })
    },
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Mail',
        guid: '' + item.guid,
        name: 'E-Mail Template ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      Vue.prototype.$api.deleteMail(item.guid, this.reload)
    },
    editItem: function (item) {
      this.$router.push('/admin/mails/' + item.guid)
    },
    formatDateTime: function (s) {
      return moment(s).format("DD.MM.YYYY HH:mm");
    },
    formatDateT: function (s) {
      return moment(s).format("DD.MM.YYYY");
    },
    reload: function () {
      var reqData = {

      }

      Vue.prototype.$api.getMailsWithFilter(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
      this.resize()
    },
    resize: function () {
      this.tableHeight = window.innerHeight - 246;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 416;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)
  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  },
}
</script>

<style scoped>

</style>
